













import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GCheckbox',
  props: {
    value: {
      required: true,
    },
    nativeValue: {
      default: true,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get(): any {
        return this.value;
      },
      set(val: any): void {
        if (this.nativeValue) {
          this.$emit('input', val);
        } else {
          this.$emit('input', val ? this.nativeValue : null);
        }
      },
    },
  },
});
